exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detect-step[data-v-fc4ab92c]{display:flex;align-items:center}.detect-step-icon[data-v-fc4ab92c]{width:12px;height:12px;border:3px solid #d1d7e1;border-radius:50%}.detect-step-text[data-v-fc4ab92c]{font-size:14px;color:rgba(0,0,0,.8509803921568627);margin-left:10px;font-weight:400}.detect-step-text__inactive[data-v-fc4ab92c]{color:rgba(0,0,0,.45098039215686275)}.status-icon[data-v-fc4ab92c]{width:12px;height:12px;margin-left:6px;margin-bottom:8px}.success[data-v-fc4ab92c]{border-color:#52c41a}.fail[data-v-fc4ab92c]{border-color:#ff4d4f}.fail-text[data-v-fc4ab92c]{color:#ff4d4f}", ""]);

// exports
